var VersionHistoryComponent = /** @class */ (function () {
    function VersionHistoryComponent() {
    }
    return VersionHistoryComponent;
}());
export { VersionHistoryComponent };
